export const FUND_MANAGERS_CAROUSEL_CATEGORY_KEY = 'management' as const;
export const FUND_MANAGERS_CAROUSEL_COMPONENT_KEY = 'fundManagersCarousel' as const;
